import {
  Card,
  Col,
  Row,
  Empty,
  Typography,
  Select,
  Space,
  Tag,
  Divider,
} from "antd";
import { useState, useMemo } from "react";
import { format } from "date-fns";

const { Title, Text } = Typography;
const { Option } = Select;

const MilestonesTab = ({ institution }) => {
  const { milestones = [] } = institution;

  const [selectedYear, setSelectedYear] = useState("All");
  const [sortOrder, setSortOrder] = useState("desc");

  // Extract available years as strings (to match selectedYear)
  const availableYears = useMemo(() => {
    const years = milestones
      .map((m) => {
        const year = new Date(m.date).getFullYear();
        return isNaN(year) ? null : year.toString();
      })
      .filter((year) => year !== null);
    return ["All", ...Array.from(new Set(years)).sort((a, b) => b - a)];
  }, [milestones]);

  // Filter and sort
  const filteredMilestones = useMemo(() => {
    let result = [...milestones];

    if (selectedYear !== "All") {
      result = result.filter(
        (m) => new Date(m.date).getFullYear().toString() === selectedYear
      );
    }

    return result.sort((a, b) => {
      const aDate = new Date(a.date);
      const bDate = new Date(b.date);
      return sortOrder === "desc" ? bDate - aDate : aDate - bDate;
    });
  }, [milestones, selectedYear, sortOrder]);

  return (
    <div className="pt-5 pb-6">
      <Space wrap className="mb-6">
        {/* Year Filter */}
        <Select
          value={selectedYear}
          onChange={setSelectedYear}
          className="min-w-[150px]"
        >
          {availableYears.map((year) => (
            <Option key={year} value={year}>
              {year}
            </Option>
          ))}
        </Select>

        {/* Sort Order */}
        <Select
          value={sortOrder}
          onChange={setSortOrder}
          className="min-w-[180px]"
        >
          <Option value="desc">Newest First</Option>
          <Option value="asc">Oldest First</Option>
        </Select>
      </Space>

      {/* No milestones */}
      {filteredMilestones.length === 0 ? (
        <Empty
          description="No milestones found for selected criteria."
          className="my-8"
        />
      ) : (
        <Row gutter={[24, 24]}>
          {filteredMilestones.map((item) => (
            <Col key={item.id} xs={24} sm={12} md={6}>
              <Card
                title={item.name}
                className="transition-all border border-gray-200! hover:shadow-sm"
              >
                <div className="text-sm text-gray-700 space-y-2">
                  {item.date && (
                    <p>
                      <strong>Date:</strong>{" "}
                      <Tag color="blue">
                        {format(new Date(item.date), "do MMMM yyyy")}
                      </Tag>
                    </p>
                  )}

                  {item.description && (
                    <>
                      <Divider className="my-2" />
                      <Text className="block leading-relaxed text-gray-600">
                        {item.description}
                      </Text>
                    </>
                  )}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default MilestonesTab;
